/**
 * Production Launch Reset Utility
 *
 * Automatically clears legacy demo/test localStorage and sessionStorage data
 * when the app version changes. This ensures returning users get a clean,
 * unused experience after each production release.
 *
 * How it works:
 * - On app boot, check the stored `lavyn_prod_version` against APP_VERSION.
 * - If different (or missing), wipe all known demo storage keys and set the new version.
 *
 * Future integration: When a new database is connected, replace the
 * localStorage-backed stores with the selected backend. This module should
 * remain as a migration / cache invalidation gate.
 */

export const APP_VERSION = '1.0.0-launch';

const LEGACY_KEYS = [
  'lavyn_history_v1',
  'lavyn_scan_history_v1',
  'lavyn_progress_v1',
  'lavyn_daily_usage_v1',
  'lavyn_user_tier_v1',
  'lavyn_ai_preferences_v2',
  'lavyn_guest_demo_v2',
  'lavyn_guest_id_v2',
  'lavyn_returning_gate_shown',
  'lavyn_ad_chat_bonus',
  'history_scroll_pos',
  'scan_input_image',
  'scan_input_type',
];

const VERSION_KEY = 'lavyn_prod_version';

export function runProdReset() {
  try {
    const stored = localStorage.getItem(VERSION_KEY);
    if (stored === APP_VERSION) return; // already on latest version

    // Wipe all legacy demo / test / dev keys
    LEGACY_KEYS.forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch {
        /* ignore storage errors */
      }
    });

    // Also clear any session-only demo state
    try {
      sessionStorage.removeItem('lavyn_returning_gate_shown');
      sessionStorage.removeItem('lavyn_ad_chat_bonus');
      sessionStorage.removeItem('history_scroll_pos');
      sessionStorage.removeItem('scan_input_image');
      sessionStorage.removeItem('scan_input_type');
    } catch {
      /* ignore */
    }

    // Mark version so we don't wipe again until next release
    localStorage.setItem(VERSION_KEY, APP_VERSION);
  } catch {
    /* silently fail if storage is unavailable */
  }
}